import { ASSET_TYPE_CONTAINER, ASSET_TYPE_PHONE, ASSET_TYPE_VEHICLE } from '../constants/asset';
import { Asset, AssetCore, AssetType } from '../types/asset';
import { FleetAsset } from '../types/fleet';
import { isBrand, isSubBrand } from './currentStates';

export const getAssetTitle = (asset: Asset | AssetCore | FleetAsset) => {
  let title = '-';
  if (isVehicleKind(asset.assetType)) {
    if (isBrand(asset.vehicle?.brand) && isSubBrand(asset.vehicle?.subBrand)) {
      title = `${asset.vehicle?.brand.name} ${asset.vehicle?.subBrand.name}, ${asset.vehicle?.licensePlate}`.trim();
    } else {
      title = asset.vehicle?.licensePlate ?? '-';
    }
  } else if (asset.assetType === ASSET_TYPE_CONTAINER && asset.container?.identifier) title = 'Contenedor';
  else if (asset.assetType === ASSET_TYPE_PHONE) title = 'Celular';
  return title;
};

export const isVehicleKind = (assetType?: AssetType) => {
  // TODO: Remove camera when they're changed to vehicle type.
  return assetType === ASSET_TYPE_VEHICLE || assetType === ('camera' as AssetType);
};
